import { Box, Text, Progress, Image } from "@chakra-ui/react";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { setLayout } from "../../redux/actions/layout";
import { pmsSteps } from "../../utilities/uiConfigData";
import { postData } from "../../utilities/axios";

const NavbarPmsSearch = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const state = useSelector((state) => state);
  const step = state.layout.pmsSearchStep;
  const pmsSearch = useSelector((state) => state.pmsSearch);
  const token = useSelector((state) => state.user.JWTToken);

  useEffect(() => {
    dispatch(setLayout("pms"));
  }, [dispatch]);

  const handleSaveAndExit = async () => {
    let req = { formData: { ...pmsSearch } };
    try {
      await postData(token, req, `${process.env.NEXT_PUBLIC_NEW_PMS_URL}/save`);
      dispatch(setLayout("main"));
      router.push("/");
    } catch (error) {
      console.error("Error posting PMS details", error);
    }
  };

  const headerStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "white",
    width: "100%",
    px: "24px",
  };

  const progressBoxStyle = {
    width: "100%",
    maxW: "container.sm",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  };

  const progressStyle = {
    width: "100%",
    maxW: "container.sm",
    my: "0.5rem",
  };

  const progressLabelStyle = {
    width: "100%",
    maxW: "container.sm",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  };

  const CtaStyle = {
    alignItems: "center",
    width: "225px",
    pl: "4",
    justifyContent: "end",
  };

  const progress = (step + 1) * (100 / pmsSteps.length);

  const renderProgressBarLabels = () => {
    return pmsSteps.map((pmsStep, idx) => {
      let color = idx === Number(step) ? "brand.300" : "brand.200";
      return (
        <Text textStyle="h7" color={color} key={idx}>
          {pmsStep.label}
        </Text>
      );
    });
  };

  return (
    <>
      {/* desktop */}
      <Box
        display={{ base: "none", lg: "block" }}
        position="fixed"
        width="100%"
        top="0"
        zIndex="10"
      >
        <Box sx={headerStyle}>
          {/*Logo*/}
          <Box style={{ cursor: "pointer" }} py="5" pr="4">
            <Link href="/" passHref prefetch={false}>
              <Image
                width={{ base: "150px", xl: "247px" }}
                height={{ base: "28px", xl: "46px" }}
                src="/images/homepage/wd-logo.png"
                alt="welldoing logo"
              />
            </Link>
          </Box>

          <Box sx={progressBoxStyle}>
            <Text as="h1" textStyle="h6" color="brand.300">
              MatchPlus
            </Text>
            <Progress
              sx={progressStyle}
              value={progress}
              size="xs"
              colorScheme="secondary"
            />
            <Box sx={progressLabelStyle}>{renderProgressBarLabels()}</Box>
          </Box>
          <Box sx={CtaStyle}>
            {/* This component required to maintain layout */}
          </Box>
        </Box>
      </Box>
      {/* mobile */}
      <Box
        display={{ base: "block", lg: "none" }}
        position="fixed"
        width="100%"
        top="0"
        zIndex="10"
      >
        <Box sx={headerStyle}>
          <Box
            display={{ base: "flex", lg: "none" }}
            py="5"
            align="center"
            cursor="pointer"
            onClick={handleSaveAndExit}
            justify="start"
          >
            {/*Logo*/}
            <Image
              src="/images/homepage/logo_icon_only.png"
              height="32px"
              width="32px"
              alt="welldoing logo"
            />
          </Box>
          <Text textStyle="h6" color="brand.300">
            MatchPlus
          </Text>
        </Box>
        <Progress
          width="100%"
          value={progress}
          size="xs"
          colorScheme="secondary"
        />
      </Box>
    </>
  );
};

export default NavbarPmsSearch;
